import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Common messages
  confirmDowngradeTitle: {
    defaultMessage: 'Are you sure you want to downgrade?',
    description: 'Title for the downgrade confirmation modal',
    id: '+zqcs7',
  },
  userRoleWarning: {
    defaultMessage: 'Downgrading your plan will remove user role controls—any users you keep will automatically receive admin access.',
    description: 'Warning message about user role control changes when downgrading',
    id: 'jLpv9t',
  },
  downgradePrimaryText: {
    defaultMessage: 'By proceeding with this subscription plan downgrade, you will lose access to:',
    description: 'Text explaining what features will be lost',
    id: 'A6iAEr',
  },
  freeDowngradePrimaryText: {
    defaultMessage:
      'By selecting the Free plan, you’ll be limited to one user and won’t have access to any order sources for processing labels.',
    description: 'Primary text for Free plan downgrade',
    id: 'TWurK2',
  },
  downgradeButtonText: {
    defaultMessage: 'Downgrade Plan',
    description: 'Button text to confirm the downgrade',
    id: 'UglSdy',
  },
  cancelButtonText: {
    defaultMessage: 'Cancel',
    description: 'Button text to cancel the downgrade',
    id: 'z4N88X',
  },

  // Feature-specific messages
  dedicatedAccountManager: {
    defaultMessage: 'Dedicated Account Manager',
    description: 'Feature: Dedicated Account Manager',
    id: 's63o3A',
  },
  userSeats: {
    defaultMessage: '{userCount} additional users',
    description: 'number of additional users',
    id: '2OS1xa',
  },
  unlimitedAutomationRules: {
    defaultMessage: 'Unlimited automation rules',
    description: 'Feature: Unlimited automation rules',
    id: 'bQ/DdW',
  },
  customTrackingPortal: {
    defaultMessage: 'Custom tracking & returns portal',
    description: 'Feature: Custom tracking and returns portal',
    id: 'rjz5Yi',
  },
  inventoryManagement: {
    defaultMessage: 'Inventory & warehouse management',
    description: 'Feature: Inventory and warehouse management',
    id: 'GCnQZ7',
  },
  advancedInventoryManagement: {
    defaultMessage: 'Advanced inventory & warehouse management',
    description: 'Feature: Advanced inventory and warehouse management',
    id: 'kdGFyU',
  },
  advancedAnalytics: {
    defaultMessage: 'Advanced analytics',
    description: 'Feature: Advanced analytics',
    id: '2y9Mc5',
  },
  autoSplitShipments: {
    defaultMessage: 'Auto-Split',
    description: 'Feature: Auto Split Orders',
    id: 'daelLR',
  },
  CubiscanIntegration: {
    defaultMessage: 'Cubiscan Integration',
    description: 'Feature: Cubiscan Integration',
    id: 'Ae5zdB',
  },
  ODBCIntegration: {
    defaultMessage: 'ODBC database connection',
    description: 'Feature: ODBC Integration',
    id: 'MUnzAr',
  },
});
